export function Member({ member, onDeleteClicked, onToggleActive }) {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '350px',
            padding: '10px 15px',
            margin: '5px 0',
            backgroundColor: '#fff',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            border: '1px solid #eee',
            opacity: member.isActive ? 1 : 0.6,
            transition: 'opacity 0.3s ease'
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <input
                    type="checkbox"
                    checked={member.isActive}
                    onChange={() => onToggleActive({ ...member, isActive: !member.isActive })}
                    style={{ cursor: 'pointer', width: '16px', height: '16px' }}
                />
                <span style={{
                    fontSize: '16px',
                    fontWeight: '500',
                    color: '#333',
                    textDecoration: member.isActive ? 'none' : 'line-through'
                }}>
                    {member.nickName}
                </span>
            </div>

            <button
                onClick={() => onDeleteClicked(member)}
                style={{
                    backgroundColor: '#fee2e2',
                    color: '#ef4444',
                    border: 'none',
                    borderRadius: '6px',
                    padding: '5px 10px',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    transition: '0.2s'
                }}
                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#fca5a5')}
                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#fee2e2')}
            >
                Видалити
            </button>
        </div>
    );
}